
import './App.css';
import 'devextreme/dist/css/dx.light.css';
import RouterPage from "./routes/RouterPage";
import { useAuthInterceptor } from './hooks/useAuthInterceptor';
import { AuthProvider } from './context/AuthContext';
import DebugAuth from './components/DebugAuth';
// import TokenMonitor from './components/TokenMonitor/TokenMonitor';

function App() {
  useAuthInterceptor();
  
  return (
    <AuthProvider>
      <RouterPage/>
      <DebugAuth />
      {/* <TokenMonitor /> */}
    </AuthProvider>
  )
}

export default App